module.exports = __webpack_public_path__ + "3a524cb9fcdaa1fd62134aac42748d29.png";